/**
 * The editor's surface tokens, built on the CircleChess tokens in
 * courseTheme.ts (which win over anything else).
 *
 * The old review screen sat on a full teal page with white cards on it; the
 * editor is meant to be calm, so teal is an accent here, not a wallpaper. The
 * canvas is a near-white with a trace of the brand teal, and the only loud
 * colour on screen is the yellow Publish button.
 *
 * Contrast, measured (WCAG 2.x, text on background):
 *   mutedText #6E6B69 on canvas 4.95 · on selected row 4.90 · on white 5.29
 *   tealDark  #2B786F on canvas 4.89 · on selected row 4.84 · white on it 5.23
 *   STATUS.warn.fg on canvas 4.70 · on selected 4.65 · STATUS.good.fg 4.69 / 4.64
 *   brownDark on flash 13.67 · brownDark on yellow 10.46
 *   inputLine #8A8785 against white 3.5 (non-text, needs 3:1)
 * STATUS.*.fg on its own STATUS.*.bg is 4.3–4.5 — under AA — so status words
 * are always set on white or the canvas, never on their tint.
 */
import {F} from '../courseTheme';

export const E = {
  canvas: '#F5F8F7',
  surface: F.white,
  line: 'rgba(38,35,34,0.10)',
  /** Input outlines: 3.5:1 against white, enough for a control boundary. */
  inputLine: '#8A8785',
  ink: F.brownDark,
  body: F.brown,
  muted: F.mutedText,
  accent: F.tealDark,
  /** Teal at 8% over white. */
  selected: '#EFF8F7',
  /** The reviewer's own chat bubble: teal at 14% over white. */
  userBubble: '#E4F3F1',
  /** The 1s highlight on text an edit changed. */
  flash: '#FDF0BF',
  pressed: 'rgba(38,35,34,0.08)',
  hover: 'rgba(38,35,34,0.04)',
  scrim: 'rgba(20,20,20,0.5)',
} as const;

/** Below this window width the rail becomes a drawer and the main area two tabs. */
export const EDITOR_BREAKPOINT = 1150;
export const RAIL_WIDTH = 272;
export const CHAT_WIDTH = 384;
export const HEADER_HEIGHT = 64;
/** Messages are capped by the server at this length. */
export const MESSAGE_LIMIT = 1000;
/** The counter appears once a message is this long. */
export const MESSAGE_COUNTER_FROM = 800;
